/**
 * Public product brand and production hostnames.
 * Engineering codename in repo/packages remains `web-studio`.
 */
export const PLATFORM_BRAND_NAME = 'hubA' as const;

/** Control-plane product title (studio.huba.info browser chrome + workspace). */
export const PLATFORM_STUDIO_PRODUCT_NAME = 'hubA STUDIO' as const;

/** Registered apex domain (lowercase). */
export const PLATFORM_DOMAIN = 'huba.info' as const;

/** Owner control plane — studio-shell (gate, onboarding, workspace, APIs). */
export const PLATFORM_STUDIO_HOST = `studio.${PLATFORM_DOMAIN}` as const;

/** Public marketing — web-marketplace at apex. */
export const PLATFORM_MARKETING_ORIGIN = `https://${PLATFORM_DOMAIN}` as const;

/** Baked artifacts + tenant media CDN. */
export const PLATFORM_CDN_HOST = `cdn.${PLATFORM_DOMAIN}` as const;

export const PLATFORM_STUDIO_ORIGIN = `https://${PLATFORM_STUDIO_HOST}` as const;
export const PLATFORM_CDN_ORIGIN = `https://${PLATFORM_CDN_HOST}` as const;
